// DesignSection.jsx

import React, { useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import "./Home.css";

// Import components
import Home2 from "../Componet/Home2";
import Homeservice from "../Componet/Homeservice";
import Home3 from "../Componet/Home3";
import About2 from "../Componet/about2";
import OurSuccess from "../Componet/OurSuccess";
import MeetOurClients from "../Componet/MeetOurClients";
import OurSuccess2 from "../Componet/OurSuccess2";
import Contactus from "../Componet/Contactus";

// Import images
import Design1 from "../Imges/Home.jpg";

// Carousel data
const carouselData = [
  {
    image: Design1,
    title: "DESIGN",
    description:
      "Crafting visual harmony through creative arrangement of elements for problem-solving solutions.",
  },
  {
    image: Design1,
    title: "INNOVATION",
    description:
      "Pushing boundaries with new ideas, transforming concepts into reality through technology and creativity.",
  },
  {
    image: Design1,
    title: "CREATIVITY",
    description:
      "Sparking originality, inspiring new perspectives, and pioneering unique solutions in design.",
  },
];

const DesignSection = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % carouselData.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <section className="design-section">
        <Carousel
          fade
          controls={false}
          indicators={false}
          activeIndex={index}
          onSelect={handleSelect}
          interval={null}
        >
          {carouselData.map((item, idx) => (
            <Carousel.Item key={idx}>
              <div
                className="carousel-slide"
                style={{ backgroundImage: `url(${item.image})` }}
              >
                <div className="carousel-overlay">
                  <AnimatePresence mode="wait">
                    <motion.div
                      key={item.title}
                      className="carousel-text"
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -20 }}
                      transition={{ duration: 0.6 }}
                    >
                      <h2 className="carousel-title">{item.title}</h2>
                      <p className="carousel-description">{item.description}</p>
                    </motion.div>
                  </AnimatePresence>
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </section>

      {/* Additional Components */}
      <Home2 />
      <Homeservice />
      <Home3 />
      <OurSuccess />
      <OurSuccess2 />
      <MeetOurClients />
      <Contactus />
    </>
  );
};

export default DesignSection;
